import { allLayers } from "../../constants/constants";
import { getRelatedFeatureIds } from "../cardsGroupsFeatures";
import { fixAndToLocaleString } from "../utils";
import { store } from "../../index";

var hoveredStateId = null;
var hoveredStateIds = [];
var hoverInfoContainer = null;
var hoverTooltipArrow = null;
var hoverCustomLevel = null;
var hoverCustomCategory = null;
var hoverCustomAppartment = null;
var hoverCustomStart = null;
var hoverCustomEnd = null;
var hoverLevelName = null;
var hoverCategoryName = null;
var hoverAppartmentName = null;
var hoverStartName = null;
var hoverEndName = null;
var lastIdHovered = null;
var hoverCostName = null
var hoverQuantityName = null
var hoverPaidName = null

const hoverOffsetX = 30;
const hoverOffsetY = 0;

function showHoverInfo(feature, point) {
    if (!hoverInfoContainer) {
        initializeHoverInfo();
    }
    hoverInfoContainer.classList.remove('d-none');
    setHoverPosition(point);
    setHoverText(feature);
}

function initializeHoverInfo() {
    hoverInfoContainer = document.getElementById('hover-info');
    hoverTooltipArrow = document.getElementById('hover-tooltip-arrow');
    hoverCustomLevel = document.getElementById('hover-custom-level');
    hoverCustomCategory = document.getElementById('hover-custom-category');
    hoverCustomAppartment = document.getElementById('hover-custom-appartment');
    hoverCustomStart = document.getElementById('hover-custom-start');
    hoverCustomEnd = document.getElementById('hover-custom-end');
    hoverLevelName = document.getElementById('hover-level-name');
    hoverCategoryName = document.getElementById('hover-category-name');
    hoverAppartmentName = document.getElementById('hover-appartment-name');
    hoverStartName = document.getElementById('hover-start-name');
    hoverEndName = document.getElementById('hover-end-name');
    hoverCostName = document.getElementById('hover-cost-name');
    hoverQuantityName = document.getElementById('hover-quantity-name');
    hoverPaidName = document.getElementById('hover-paid-name');
}

function setHoverPosition(point) {
    let containerWidth = hoverInfoContainer.offsetWidth;
    let spaceAvailable = (window.innerWidth - point.x - hoverOffsetX) > containerWidth;
    let pxToLeft = 0;
    if (!spaceAvailable) {
        pxToLeft = containerWidth + 2*hoverOffsetX;
        hoverTooltipArrow.classList.remove('tooltip-arrow-left');
        hoverTooltipArrow.classList.add('tooltip-arrow-right');
    } else {
        hoverTooltipArrow.classList.remove('tooltip-arrow-right');
        hoverTooltipArrow.classList.add('tooltip-arrow-left');
    }
    let pos = `translate(
        ${point.x + hoverOffsetX - pxToLeft}px,
        calc(-50% + ${point.y + hoverOffsetY}px)
    )`;
    hoverInfoContainer.style.transform = pos;
}


function setHoverText(feature) {
    const state = store.getState();
    const userRole = state.userRole;
    const paint = state.paint;

    if (lastIdHovered !== feature.id) {
        lastIdHovered = feature.id;
        hoverCustomLevel.textContent = `${feature.properties.custom_level}:`;
        hoverCustomCategory.textContent = `${feature.properties.custom_category}:`;
        hoverLevelName.textContent = feature.properties.level_name;
        hoverCategoryName.textContent = feature.properties.category_name;
        if (feature.properties.custom_appartment && feature.properties.appartment_name) {
            hoverCustomAppartment.textContent = `${feature.properties.custom_appartment}:`;
            hoverAppartmentName.textContent = feature.properties.appartment_name;
            hoverCustomAppartment.parentNode.classList.remove('d-none');
        } else {
            hoverCustomAppartment.parentNode.classList.add('d-none');
        }
        if (feature.properties.custom_start && feature.properties.custom_end) {
            hoverCustomStart.textContent = `${feature.properties.custom_start}:`;
            hoverCustomEnd.textContent = `${feature.properties.custom_end}:`;
            hoverStartName.textContent = `${feature.properties.start}`;
            hoverEndName.textContent = `${feature.properties.end}`;
            hoverCustomStart.parentNode.classList.remove('d-none');
            hoverCustomEnd.parentNode.classList.remove('d-none');
        } else {
            hoverCustomStart.parentNode.classList.add('d-none');
            hoverCustomEnd.parentNode.classList.add('d-none');
        }

        if(feature.properties.cost != null && feature.properties.cost != undefined){
            hoverCostName.textContent = `$${fixAndToLocaleString(feature.properties.cost)}`;
            hoverCostName.parentNode.classList.remove('d-none');
        } else {
            hoverCostName.parentNode.classList.add('d-none');
        }
        if(feature.properties.quantity != null && feature.properties.unit != undefined){
            hoverQuantityName.textContent = `${fixAndToLocaleString(feature.properties.quantity)} ${feature.properties.unit}`;
            hoverQuantityName.parentNode.classList.remove('d-none');
        } else {
            hoverQuantityName.parentNode.classList.add('d-none');
        }
        if(userRole.sensitive_data && paint === 'paid_physical_progress'){
            hoverPaidName.textContent = `${feature.properties.paid_percentage}`
            hoverPaidName.parentNode.classList.remove('d-none')
        } else {
            hoverPaidName.parentNode.classList.add('d-none')
        }
    }
}

function hideHoverInfo() {
    if (!hoverInfoContainer) {
        hoverInfoContainer = document.getElementById('hover-info');
    }
    hoverInfoContainer.classList.add('d-none');
}

const addHoverState = (e) => {
    if (e.features.length > 0) {
        let map = e.target;
        let hoveredFeature = e.features[0];
        showHoverInfo(hoveredFeature, e.point);
        if (hoveredStateId === hoveredFeature.id) return;
        hoveredStateIds.forEach(hoveredStateId => {
            map.setFeatureState(
                { source: 'cards', id: hoveredStateId },
                { hover: false }
            );
        })
        hoveredStateId = hoveredFeature.id;
        hoveredStateIds = [hoveredFeature.id];
        map.setFeatureState(
            { source: 'cards', id: hoveredFeature.id },
            { hover: true }
        );
        let relatedFeatureIds = getRelatedFeatureIds(map, hoveredFeature);
        for (const featureId of relatedFeatureIds) {
            hoveredStateIds.push(featureId);
            map.setFeatureState(
                { source: 'cards', id: featureId },
                { hover: true }
            );
        }
    }
}

const removeHoverState = (e) => {
    e.target.getCanvas().style.cursor = ''

    if (hoveredStateIds.length) {
        hoveredStateIds.forEach(hoveredStateId => {
            e.target.setFeatureState(
                { source: 'cards', id: hoveredStateId },
                { hover: false }
            );
        });
    }
    hoveredStateId = null;
    hoveredStateIds = [];
    hideHoverInfo();
}

const addMousePointer = (e) => {
    e.target.getCanvas().style.cursor = 'pointer';
}

export default function hoverManager (map, removeListeners=false) {
    for (const layer of allLayers) {
        if (layer === 'cardOutlinePolygonLayer') continue;
        if (removeListeners) {
            map.off('mouseenter', layer, addMousePointer)
            map.off('mousemove', layer, addHoverState)
            map.off('mouseleave', layer, removeHoverState)
        } else {
            map.on('mouseenter', layer, addMousePointer)
            map.on('mousemove', layer, addHoverState)
            map.on('mouseleave', layer, removeHoverState)
        }
    }
}